import { useTheme } from "@mui/material";
import ActionIconBase, { GlyphBox } from "./ActionIconBase";
import { IconProps } from "./icon.interface";

/**
 * Send Email — a paper plane (`SendOutlined`) rather than an envelope. An
 * envelope reads as "there is mail here"; this sends one, and the plane is the
 * glyph that says so.
 *
 * `accent.dark`, so the Users row reads as four distinct actions: Edit
 * (secondary), Login As (black), Send Email (grey), Delete (red).
 */
const GLYPH =
  "m4.01 6.03 7.51 3.22-7.52-1 .01-2.22m7.5 8.72L4 17.97v-2.22l7.51-1M2.01 3 2 10l15 2-15 2 .01 7L23 12 2.01 3z";

/** `GLYPH`s own ink box — see `GlyphBox` in ActionIconBase. */
const GLYPH_BOX: GlyphBox = [2, 3, 21, 18];

export default function SendEmailIcon(props: IconProps) {
  const theme = useTheme();
  return (
    <ActionIconBase
      {...props}
      color={theme.palette.accent.dark}
      glyph={GLYPH}
      glyphBox={GLYPH_BOX}
    />
  );
}
